import { render, staticRenderFns } from "./saveEmailTemplate.vue?vue&type=template&id=0e6af25d&"
import script from "./saveEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./saveEmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports